import React, { useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const TermsOfService = () => {
  useEffect(() => {
    document.title = 'Terms of Service | Sikka IT Solutions';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center">
              <img src={require('../assets/sikka-logo.jpg')} alt="Sikka IT Solutions" className="h-12 w-auto object-contain" />
            </a>
            <Button className="bg-blue-600 hover:bg-blue-700" onClick={() => window.location.href = '/'}>
              Back to Home <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold text-slate-900 mb-2">Terms of Service</h1>
        <p className="text-sm text-slate-500 mb-10">Last updated: March 16, 2026</p>

        <div className="prose prose-slate max-w-none space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">1. Acceptance of Terms</h2>
            <p>By accessing and using the services provided by Sikka IT Solutions ("Company", "we", "us", or "our"), located at Sikka House, 6 La Place, Hazratganj, Lucknow - 226001, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">2. Services</h2>
            <p>Sikka IT Solutions provides custom software development, web and mobile application development, enterprise solutions (CRM, ERP, e-commerce), AI-powered automation, cloud solutions, DevOps services, API integration, and digital marketing services. The specific scope, deliverables, timelines, and fees for each project shall be outlined in a separate Statement of Work (SOW) or project agreement.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">3. Project Engagement</h2>
            <p>All projects commence upon mutual agreement of the SOW and receipt of applicable advance payments as outlined therein. Project timelines are estimates and may be subject to change based on scope modifications, client feedback cycles, and third-party dependencies. Any changes to the agreed scope must be documented in writing and may affect project timelines and costs.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">4. Payment Terms</h2>
            <p>Payment terms shall be as specified in the individual project agreement or SOW. Unless otherwise stated, invoices are due within 15 days of issuance. Late payments may incur interest at the rate of 1.5% per month. The Company reserves the right to suspend work on any project with outstanding payments exceeding 30 days.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">5. Intellectual Property</h2>
            <p>Upon full payment, the client shall own all intellectual property rights to the custom-developed software and deliverables as specified in the SOW. The Company retains the right to use general knowledge, skills, experience, tools, and methodologies acquired during the project. Pre-existing intellectual property, frameworks, and libraries used in development remain the property of their respective owners.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">6. Confidentiality</h2>
            <p>Both parties agree to maintain strict confidentiality regarding proprietary information, business strategies, technical specifications, and any sensitive data exchanged during the engagement. This obligation survives the termination of the business relationship for a period of two (2) years. Separate Non-Disclosure Agreements (NDAs) may be executed upon request.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">7. Warranty & Support</h2>
            <p>The Company provides a warranty period of 30 days from project delivery during which any bugs or defects in the delivered software will be fixed at no additional charge. Extended support and maintenance plans are available at additional cost. The warranty does not cover issues arising from unauthorized modifications, third-party integrations not part of the original scope, or misuse of the software.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">8. Limitation of Liability</h2>
            <p>To the maximum extent permitted by applicable law, Sikka IT Solutions shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits, revenue, data, or business opportunities arising from the use of our services. Our total aggregate liability shall not exceed the total fees paid by the client for the specific project giving rise to the claim.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">9. Termination</h2>
            <p>Either party may terminate the engagement with 15 days written notice. In case of termination, the client shall pay for all work completed up to the date of termination. Any advance payments for undelivered work shall be refunded on a pro-rata basis after deducting costs incurred.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">10. Governing Law</h2>
            <p>These Terms of Service shall be governed by and construed in accordance with the laws of India. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in Lucknow, Uttar Pradesh, India.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">11. Contact</h2>
            <p>For any questions regarding these Terms of Service, please contact us at:</p>
            <p className="mt-2">
              <strong>Sikka IT Solutions</strong><br />
              Sikka House, 6 La Place, Hazratganj, Lucknow - 226001<br />
              Email: raunak@sikkanet.com
            </p>
          </section>
        </div>
      </main>

      <footer className="bg-slate-950 text-slate-400 text-sm text-center py-6">
        <p>&copy; 2026 Sikka IT Solutions. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default TermsOfService;
